<section class="py-4">
  <!-- LIST VIEW -->
  <app-newsticker-view
    *ngIf="!showCreate"
    [newsList]="news"
    (addClicked)="handleAdd()"
  >
  </app-newsticker-view>

  <!-- ADD VIEW -->
  <app-add-news *ngIf="showCreate" (backtolist)="handleBackToList()">
  </app-add-news>
</section>
